
  if (!customElements.get('metafield-product-add')) {
    customElements.define(
      'metafield-product-add',
      class MetafieldProductAdd extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('.cpg-add');
          this.label = this.button?.querySelector('.cpg-add__label');
          this.variantSelect = this.querySelector('[data-role="variant"]');
          this.priceEl = this.querySelector('.mpu-card__sale');
          this.compareEl = this.querySelector('.mpu-card__compare');

          this.variantSelect?.addEventListener('change', () => {
            const opt = this.variantSelect.selectedOptions[0];
            if (!opt || !this.button) return;

            const available = opt.dataset.available === 'true';
            this.button.dataset.variantId = opt.value;
            this.button.disabled = !available;
            if (this.label && this.button.dataset.loading !== 'true') {
              this.label.textContent = available ? '+ Add' : 'Sold out';
            }

            if (this.priceEl && opt.dataset.price) this.priceEl.textContent = opt.dataset.price;
            if (this.compareEl) {
              this.compareEl.textContent = opt.dataset.compare || '';
              this.compareEl.hidden = !opt.dataset.compare;
            }
          });
        }
      }
    );
  }

  /* ---------- Global .cpg-add handler (shared with your other sections) ----------
     Guarded by window.cpgLoaded so it only runs once per page. */
  (() => {
    if (window.cpgLoaded) return;
    window.cpgLoaded = true;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    async function notifyTheme(cart, variantId, productId) {
      /* 1. Horizon native event */
      try {
        const { CartAddEvent } = await import('@theme/events');
        document.dispatchEvent(
          new CartAddEvent({}, String(variantId), {
            source: 'cpg-add',
            itemCount: cart.item_count || 0,
            productId: String(productId || ''),
            didError: false
          })
        );
        return;
      } catch (error) {
        /* not Horizon's @theme/events — try the fallback below */
      }

      /* 2. Fallback: CartLinesUpdateEvent */
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const deferred = CartLinesUpdateEvent.createPromise();

        let horizonCart;
        try {
          horizonCart = CartLinesUpdateEvent.createCartFromAjaxResponse(cart);
        } catch (error) {
          horizonCart = { totalQuantity: cart.item_count || 0, items: cart.items || [] };
        }

        document.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise
        }));

        deferred.resolve({
          cart: horizonCart,
          detail: { items: cart.items || [], itemCount: cart.item_count || 0, source: 'cpg-add', didError: false }
        });
      } catch (error) {
        console.warn('Horizon cart event unavailable', error);
      }
    }

    /* 3. Section refresh (only runs if these IDs exist on the page) */
    async function refreshSections() {
      const sectionIds = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
      await Promise.all(sectionIds.map(async (sectionId) => {
        const current = document.getElementById(sectionId);
        if (!current) return;
        try {
          const res = await fetch(root + '?section_id=' + sectionId);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById(sectionId);
          if (fresh) current.innerHTML = fresh.innerHTML;
        } catch (error) {
          console.warn('Cart section update failed', error);
        }
      }));
    }

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('.cpg-add[data-variant-id]:not(:disabled)');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.dataset.loading === 'true') return;
      button.dataset.loading = 'true';

      const label = button.querySelector('.cpg-add__label') || button;
      const originalText = label.textContent;
      label.textContent = 'Adding...';

      try {
        const variantId = button.dataset.variantId;

        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Add to cart failed');

        const productId = data.items && data.items[0] ? data.items[0].product_id : '';

        const cartResponse = await fetch(root + 'cart.js');
        const cart = await cartResponse.json();

        await notifyTheme(cart, variantId, productId);
        await refreshSections();

        label.textContent = 'Added';
        setTimeout(() => {
          label.textContent = originalText;
          button.dataset.loading = 'false';
        }, 1200);
      } catch (error) {
        console.error('cpg add to cart error:', error);
        label.textContent = error.message && error.message !== 'Add to cart failed' ? error.message : 'Try again';
        setTimeout(() => {
          label.textContent = originalText;
          button.dataset.loading = 'false';
        }, 2000);
      }
    }, true);
  })();